import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: "Trabajo 8 horas y creía que no me daba el tiempo. Con el cronograma maestro rendí 4 finales en un mes. Recomiendo",
  name: 'Nicolás B.',
  location: "Mendoza · Argentina",
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/02c40458-26cf-4e25-938b-5aa61aaded42.jpg'
}, {
  quote: 'La lectura por capas me cambió todo. Antes leía tres veces el mismo apunte; ahora entiendo el texto en la primera pasada.',
  name: 'Julieta M.',
  location: "La Plata · Argentina",
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/a44fda8b-4d21-440c-8727-e11baeae9803.jpg'
}, {
  quote: "Los bonos son oro. Me armo preguntas de examen del programa real y llego al parcial sabiendo qué me van a tomar.",
  name: 'Tomás A.',
  location: "Santa Fe · Argentina",
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/840813de-e17e-4f55-a28b-b7ae909897c1.jpg'
}, {
  quote: "Venía de recursar dos veces la misma materia. El Tomo 12 me ordenó la cabeza y la aprobé con 8 en el siguiente examen.",
  name: 'Sofía L.',
  location: "Canelones · Uruguay",
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/52988588-7d0f-4220-b2f1-69c7636eaa15.jpg'
}];
export function MoreTestimonials() {
  return <section aria-label="Más testimonios" className="mx-auto mt-12 w-full max-w-5xl" data-id="element-111" data-mp="3r5ttzzivdphr">
      <h2 className="text-center font-display text-2xl font-black text-white sm:text-3xl" data-id="element-112" data-mp="3m80q5d51h7kn">
        ❤️ Más estudiantes que ya lo aplican
      </h2>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-113" data-mp="3chfhsxzkcooj">
        {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        delay: i % 2 * 0.1
      }} className="flex flex-col rounded-2xl border border-white/10 bg-ink-2 p-5" data-id="element-114" data-mp="3cf30mn1mqicj" data-mpi={i}>
            <figcaption className="flex items-center gap-3" data-id="element-115" data-mp="2oshawf5cay8z">
              <img src={t.img} alt={t.name} className="h-11 w-11 shrink-0 rounded-full object-cover ring-2 ring-gold/50" data-id="element-116" data-mp="2ttok8in4s5hr" />
              <div className="min-w-0" data-id="element-117" data-mp="2ewxpwnsbdjz0">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-id="element-118" data-mp="2ey8wevd595tt">
                  <span className="text-sm font-bold text-white" data-id="element-119" data-mp="2jv7prbozh8qy">{t.name}</span>
                  <span className="flex gap-0.5 text-gold" data-id="element-120" data-mp="37luz81ejs6fm">
                    {Array.from({
                  length: 5
                }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" data-id="element-121" data-mp="3clhc29qgrknw" data-mpi={k} />)}
                  </span>
                </div>
                <div className="text-xs text-white/50" data-id="element-122" data-mp="32tk1943daupp">📍 {t.location}</div>
              </div>
            </figcaption>
            <blockquote className="mt-4 flex-1 border-t border-white/10 pt-4 text-[15px] leading-relaxed text-white/80" data-id="element-123" data-mp="3qj5vdd4vujqu">
              “{t.quote}”
            </blockquote>
          </motion.figure>)}
      </div>
    </section>;
}